/**
 * WordPress dependencies
 */

import { store, getContext, getElement } from '@wordpress/interactivity';


const { state } = store('gt/ctv', {
    actions: {
        changeNbPers: (e) => {
            const context = getContext();
            let nbPers = e.target.value;
            context.gtNbPers = nbPers;
            state.gtNbPers = nbPers;
        },
        changeType: (e) => {
            const context = getContext();
            const element = getElement();
            const selectedType = e.target.value;
            const typeArray = selectedType ? [selectedType] : [];

            context.gtType = typeArray;
            state.gtType = typeArray;

            if (selectedType) {
                Cookies.set('gtType', selectedType);
            } else {
                Cookies.remove('gtType');
            }

            if (context.showSearch === false) {
                const form = element?.ref?.closest('form');
                if (form) {
                    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                }
            }
        },
        changeCamping: (e) => {
            const context = getContext();
            let gtCamping = e.target.value;
            context.gtCamping = gtCamping;
            state.gtCamping = gtCamping;
        },
        sortHebergements: (e) => {
            const domSort = document.querySelector('.gt-hebergements-sort input[type="radio"]:checked');
            const hasPriceSort = !!domSort;
            if (hasPriceSort) {
                state.sort_order = domSort.value;
            }
            document.querySelectorAll('.wp-block-post-template').forEach(container => {
            const hebergements = [...container.querySelectorAll('.hebergement')];
            
            // Fonction pour obtenir le statut de disponibilité d'un hébergement
            const getStatutOrder = (hebergement) => {
                const dispoBlock = hebergement.querySelector('[data-wp-bind--data-gt-statut]');
                if (!dispoBlock) return 3; // Indisponible par défaut
                const statut = dispoBlock.getAttribute('data-gt-statut');
                // Ordre : disponible (1), contreproposition (2), indisponible (3)
                if (statut === 'disponible') return 1;
                if (statut === 'contreproposition') return 2;
                return 3; // indisponible
            };
            
            hebergements.sort((a, b) => {
                // D'abord trier par statut de disponibilité
                const statutA = getStatutOrder(a);
                const statutB = getStatutOrder(b);
                
                if (statutA !== statutB) {
                    return statutA - statutB;
                }

                // Si aucun tri par prix n'est sélectionné, conserver l'ordre d'origine
                if (!hasPriceSort) {
                    return 0;
                }
                
                // Si même statut, trier par prix
                const priceA = parseFloat(a.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;
                const priceB = parseFloat(b.querySelector('.gt-ws-ctv-data-price')?.dataset.gtPrice) || 0;
                return state.sort_order === 'asc' ? priceA - priceB : priceB - priceA;
            });
            const fragment = document.createDocumentFragment();
            hebergements.forEach(hebergement => fragment.appendChild(hebergement));
            container.appendChild(fragment);
            });
        },  
        toggleStickyForm: (e) => {
            const element = getElement();
            const wrapper = element.ref.closest('.wp-block-gt-gt-ws-ctv-form-resa');
            wrapper.classList.toggle('toggled');
            syncStickyButtonState(wrapper);
        },
        closeStickyFormOnScroll: (e) => {
            const element = getElement();
            const wrapper = element.ref;
            if (wrapper.classList.contains('toggled') && !wrapper._caleranOpen) {
                wrapper.classList.remove('toggled');
                syncStickyButtonState(wrapper);
            }
        },
        initStickyObserver: () => {
            const element = getElement();
            const formEl = element.ref;
            initStickyObserverForEl(formEl);
        },
        submitForm: (e) => {
            
            if(e) e.preventDefault();

            const url = new URL(window.location.href);
            if (url.searchParams.has('gtNoResults')) {
                state.isLoading = true;
            }


            if(state.loaded == true && e == undefined) return;

            state.isLoading = true;
            state.loaded = false;

            if(state.gtArrival == "null" || state.gtDeparture == "null" || state.gtNbPers == "null"){
                state.isLoading = false;
                return;
            }

            const domSort = document.querySelector('.gt-hebergements-sort input[type="radio"]:checked');
            if (domSort) {
                state.sort_order = domSort.value;
            }

            Cookies.set('gtArrival', state.gtArrival);
            Cookies.set('gtDeparture', state.gtDeparture);
            Cookies.set('gtNbPers', state.gtNbPers);

            // Type sélectionné : prioriser l'état CTV, sinon retomber sur le cookie existant
            let selectedType = state.gtType && state.gtType.length ? state.gtType[0] : '';
            if (!selectedType) {
                const existingTypeCookie = Cookies.get('gtType');
                if (existingTypeCookie) {
                    selectedType = existingTypeCookie;
                }
            }
            if (selectedType) {
                Cookies.set('gtType', selectedType);
                url.searchParams.set('gtType', selectedType);
            } else {
                Cookies.remove('gtType');
                url.searchParams.delete('gtType');
            }

            Cookies.set('gtCamping', state.gtCamping);

            // Définir les paramètres GET dans l'URL
            url.searchParams.set('arrival', state.gtArrival);
            url.searchParams.set('departure', state.gtDeparture);
            url.searchParams.set('nbPers', state.gtNbPers);

            // Mise à jour de l'URL sans recharger la page
            // window.history.pushState({}, '', url.toString());


            // Close menu
            if(store('gt-menu-burger').actions.length > 0){
                store('gt-menu-burger').actions.closeMenu();
            }


            // Fonction pour obtenir l'URL sans les paramètres de recherche
            function getBaseUrl(url) {
                let baseUrl = new URL(url);
                baseUrl.search = ''; // Supprimer les paramètres de recherche
                return baseUrl.toString();
            }

            const context = getContext();
            const currentBaseUrl = getBaseUrl(window.location.toString());
            const destBase = context.destination ? getBaseUrl(context.destination) : currentBaseUrl;

            // Sur la page de recherche (même page que la destination) : repartir de l’URL actuelle
            // pour conserver les paramètres de filtres (rooms, capacity, types, sort, etc.) générés par le bloc filtres.
            let destinationUrl;
            if (currentBaseUrl === destBase) {
                destinationUrl = new URL(window.location.href);
            } else {
                destinationUrl = new URL(context.destination || window.location.href);
            }

            destinationUrl.searchParams.set('arrival', state.gtArrival);
            destinationUrl.searchParams.set('departure', state.gtDeparture);
            destinationUrl.searchParams.set('nbPers', state.gtNbPers);
            if (selectedType) {
                destinationUrl.searchParams.set('gtType', selectedType);
            } else {
                destinationUrl.searchParams.delete('gtType');
            }
            destinationUrl.searchParams.delete('gtNoResults');

            // Nettoyer l'éventuel ancien paramètre gtResetFilters de l'URL
            destinationUrl.searchParams.delete('gtResetFilters');

            // Au submit du formulaire : toujours navigation complète vers la destination
            // pour éviter que le routeur Interactivity (soft nav) casse les styles sur les pages
            // qui contiennent déjà un bloc hébergement (gt-ws-ctv-hebergements-query, etc.).
            const isFormSubmit = e && e.type === 'submit';
            // Au submit du formulaire : toujours navigation complète vers la destination
            // pour éviter que le routeur Interactivity (soft nav) casse les styles sur les pages
            // La navigation soft peut aussi casser les styles des éléments en dehors du DOM principal
            // (comme le bouton "back-to-top"), donc on utilise toujours window.location.replace() au submit
            if (isFormSubmit) {
                // Scroll auto uniquement si on reste sur la même page.
                // Si le formulaire envoie vers une page de destination configurée, ne pas forcer le scroll.
                if (currentBaseUrl === destBase) {
                    destinationUrl.searchParams.set('gtScroll', 'results');
                } else {
                    destinationUrl.searchParams.delete('gtScroll');
                }
                // Toujours utiliser window.location.replace() au submit pour éviter les problèmes de styles
                window.location.replace(destinationUrl.toString());
                return;
            }

            // Mise à jour d’URL sans submit (filtres, etc.) : navigation côté client si la page a des dispos
            const hasDispoInContent = document.querySelector('.single-hebergement') || document.querySelector('.wp-block-gt-gt-ws-ctv-disponibilites') || document.querySelector('.gt-ws-ctv-disponibilites-query') || document.querySelector('.gt-ws-ctv-indisponibles-query');
            if (hasDispoInContent) {
                updateURL(destinationUrl);
            } else if (getBaseUrl(window.location.toString()) !== getBaseUrl(destinationUrl.toString()) && context && context.destination) {
                window.location.replace(destinationUrl.toString());
            }

        },
        callbacks:{
          
        }
    }
});

/**
 * Initialise le sticky observer sur un élément formEl donné.
 * Peut être appelé plusieurs fois : si le sentinel est devenu orphelin (Rocket a
 * remplacé le DOM), on le supprime et on en recrée un propre.
 */
const isStickyOnMobile = (formEl) => formEl.classList.contains('sticked-on-mobile') && window.innerWidth < 1024;

/**
 * Synchronise l'affichage des boutons open/close du sticky
 * en fonction de la présence de la classe toggled sur le wrapper.
 */
const syncStickyButtonState = (wrapper) => {
    const isOpen = wrapper.classList.contains('toggled');
    const btnOpen = wrapper.querySelector('.gt-ws-ctv-resa-sticky-button--open');
    const btnClose = wrapper.querySelector('.gt-ws-ctv-resa-sticky-button--close');
    if (btnOpen) btnOpen.style.display = isOpen ? 'none' : '';
    if (btnClose) btnClose.style.display = isOpen ? '' : 'none';
};

const initStickyObserverForEl = (formEl) => {
    if (!formEl || !formEl.classList.contains('is-sticky')) return;

    const wrapper = formEl.closest('.wp-block-gt-gt-ws-ctv-form-resa') || formEl.parentElement;
    if (!wrapper) return;

    // La classe sticked est déjà posée en PHP sur mobile.
    // Sur desktop (>= 1024px), on la retire immédiatement car c'est l'observer qui gère.
    if (formEl.classList.contains('sticked-on-mobile') && window.innerWidth >= 1024) {
        formEl.classList.remove('sticked');
    }

    // Si un sentinel existant est toujours connecté au même wrapper, ne rien faire.
    if (formEl._stickyObserverInitialized && formEl._stickySentinel && formEl._stickySentinel.isConnected) return;

    // Nettoyer l'ancienne observation si elle existe (cas Rocket : DOM remplacé).
    if (formEl._stickyActivationObserver) {
        formEl._stickyActivationObserver.disconnect();
    }
    if (formEl._stickyDeactivationObserver) {
        formEl._stickyDeactivationObserver.disconnect();
    }
    if (formEl._stickySentinel && formEl._stickySentinel.isConnected) {
        formEl._stickySentinel.remove();
    }

    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;width:1px;pointer-events:none;visibility:hidden;margin:0;padding:0;border:none;';
    wrapper.after(sentinel);

    const activationObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (!entry.isIntersecting) {
                    formEl.classList.add('sticked');
                }
            });
        },
        { threshold: 0, rootMargin: '-100px 0px 0px 0px' }
    );

    const deactivationObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                // Sur mobile avec stickyOnMobile, on ne retire sticked que si on est
                // revenu tout en haut de la page (sentinel visible ET pas en mode mobile sticky).
                // On ne ferme pas le formulaire si le calendrier Caleran est ouvert.
                if (entry.isIntersecting && !isStickyOnMobile(formEl) && !formEl._caleranOpen) {
                    formEl.classList.remove('sticked');
                    formEl.classList.remove('toggled');
                    syncStickyButtonState(formEl);
                }
            });
        },
        { threshold: 0, rootMargin: '0px 0px 0px 0px' }
    );

    activationObserver.observe(sentinel);
    deactivationObserver.observe(sentinel);

    formEl._stickyObserverInitialized = true;
    formEl._stickySentinel = sentinel;
    formEl._stickyActivationObserver = activationObserver;
    formEl._stickyDeactivationObserver = deactivationObserver;

    // Gérer le resize : si on passe au dessus de 1024px, on laisse l'observer reprendre la main.
    // Si on repasse sous 1024px avec stickyOnMobile, on remet sticked.
    if (formEl.classList.contains('sticked-on-mobile') && !formEl._stickyResizeListener) {
        formEl._stickyResizeListener = () => {
            if (isStickyOnMobile(formEl)) {
                formEl.classList.add('sticked');
            }
        };
        window.addEventListener('resize', formEl._stickyResizeListener);
    }
};

/**
 * Scanne tous les blocs form-resa sticky présents dans le DOM et initialise leur observer.
 * Appelé au chargement initial et après chaque intervention de Rocket (prefetch, cache, etc.).
 */
const initAllStickyObservers = () => {
    document.querySelectorAll('.gt-ws-ctv-form-resa.is-sticky').forEach((formEl) => {
        initStickyObserverForEl(formEl);
        // S'assurer que le bouton close est bien masqué à l'init
        syncStickyButtonState(formEl);
    });
};

// Déclenchement initial
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStickyObservers);
} else {
    initAllStickyObservers();
}

// Ré-init après une navigation Rocket (prefetch / cache swap).
// Rocket utilise des events custom selon sa version :
document.addEventListener('rocket-preload', initAllStickyObservers);
document.addEventListener('wpr-ajaxified-loaded', initAllStickyObservers);
// Compatibilité avec d'autres plugins de prefetch (Flying Pages, etc.)
window.addEventListener('popstate', initAllStickyObservers);

// Fermeture au clic en dehors du formulaire sticky
document.addEventListener('click', (e) => {
    document.querySelectorAll('.gt-ws-ctv-form-resa.is-sticky.toggled').forEach((formEl) => {
        if (!formEl.contains(e.target) && !formEl._caleranOpen) {
            formEl.classList.remove('toggled');
            syncStickyButtonState(formEl);
        }
    });
}, true);

/**
 * Init Caleran sans Interactivity API.
 * On garde Caleran (jQuery) mais le déclenchement se fait en vanilla JS (DOMContentLoaded + évènements).
 */
const initCaleranVanilla = () => {
    // Caleran est un plugin jQuery: si pas chargé, on ne fait rien.
    if (typeof window.jQuery === 'undefined' || typeof window.moment === 'undefined') return;
    if (!jQuery.fn || typeof jQuery.fn.caleran !== 'function') return;

    // Labels + icons
    let language = 'fr';
    if (jQuery('html').attr('lang')) {
        language = jQuery('html').attr('lang').slice(0, 2);
    }
    const caleranButtonLabels = language === 'en'
        ? { cancelLabel: 'Cancel', applyLabel: 'Apply' }
        : { cancelLabel: 'Annuler', applyLabel: 'Valider' };

    const prevMonthIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M10 12L6 8L10 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    const nextMonthIcon = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    // Priorité : paramètres URL > cookies > state (pour que submitForm / fetch restent cohérents)
    const urlParams = new URLSearchParams(window.location.search);
    const urlArrival = urlParams.get('arrival');
    const urlDeparture = urlParams.get('departure');
    const urlNbPers = urlParams.get('nbPers');

    const cookieArrival = Cookies.get('gtArrival');
    const cookieDeparture = Cookies.get('gtDeparture');
    const cookieNbPers = Cookies.get('gtNbPers');

    let gtArrival = state.gtArrival;
    let gtDeparture = state.gtDeparture;
    if (urlArrival && moment(urlArrival, 'DD/MM/YYYY', true).isValid()) {
        gtArrival = urlArrival;
        state.gtArrival = urlArrival;
        Cookies.set('gtArrival', urlArrival);
    } else if (cookieArrival && cookieArrival !== 'null') {
        gtArrival = cookieArrival;
        if (cookieArrival !== state.gtArrival) state.gtArrival = cookieArrival;
    }
    if (urlDeparture && moment(urlDeparture, 'DD/MM/YYYY', true).isValid()) {
        gtDeparture = urlDeparture;
        state.gtDeparture = urlDeparture;
        Cookies.set('gtDeparture', urlDeparture);
    } else if (cookieDeparture && cookieDeparture !== 'null') {
        gtDeparture = cookieDeparture;
        if (cookieDeparture !== state.gtDeparture) state.gtDeparture = cookieDeparture;
    }
    if (urlNbPers) {
        const nb = Math.max(1, Math.min(99, parseInt(urlNbPers, 10)));
        if (!isNaN(nb)) {
            state.gtNbPers = String(nb);
            Cookies.set('gtNbPers', String(nb));
        }
    } else if (cookieNbPers && cookieNbPers !== 'null') {
        if (cookieNbPers !== state.gtNbPers) state.gtNbPers = cookieNbPers;
    }

    const generateRanges = (arrivalDate) => {
        const arrivalMoment = moment(arrivalDate);
        const ranges = [];

        const getNextWeekday = (date, weekday) => {
            let diff = weekday - date.day();
            if (diff <= 0) diff += 7;
            return date.clone().add(diff, 'days');
        };

        ranges.push({
            title: '1 semaine',
            startDate: arrivalMoment,
            endDate: arrivalMoment.clone().add(1, 'weeks')
        });

        ranges.push({
            title: '2 semaines',
            startDate: arrivalMoment,
            endDate: arrivalMoment.clone().add(2, 'weeks')
        });

        ranges.push({
            title: '3 semaines',
            startDate: arrivalMoment,
            endDate: arrivalMoment.clone().add(3, 'weeks')
        });

        const startWednesday = getNextWeekday(arrivalMoment, 3);
        ranges.push({
            title: 'Du mercredi au mercredi',
            startDate: startWednesday,
            endDate: startWednesday.clone().add(1, 'weeks')
        });

        const startFriday = getNextWeekday(arrivalMoment, 5);
        ranges.push({
            title: 'Du vendredi au vendredi',
            startDate: startFriday,
            endDate: startFriday.clone().add(1, 'weeks')
        });

        const startSaturday = getNextWeekday(arrivalMoment, 6);
        ranges.push({
            title: 'Du samedi au samedi',
            startDate: startSaturday,
            endDate: startSaturday.clone().add(1, 'weeks')
        });

        return ranges;
    };

    // Init par formulaire pour éviter les collisions si plusieurs blocs sur la page.
    document.querySelectorAll('.gt-ws-ctv-form-resa').forEach((formEl) => {
        const mergedInput = formEl.querySelector('.gt-caleran-merged');
        const arrivalInput = formEl.querySelector('.gt-caleran-arrival');
        const departureInput = formEl.querySelector('.gt-caleran-departure');

        const minDate = moment(state.openingDate) < moment() ? moment() : moment(state.openingDate);
        const maxDate = moment(state.closingDate);

        if (mergedInput) {
            const $merged = jQuery(mergedInput);
            if ($merged.data('caleran')) return;

            $merged.caleran({
                startDate: gtArrival && moment(gtArrival, 'DD/MM/YYYY').isValid() ? moment(gtArrival, 'DD/MM/YYYY') : null,
                endDate: gtDeparture && moment(gtDeparture, 'DD/MM/YYYY').isValid() ? moment(gtDeparture, 'DD/MM/YYYY') : null,
                minDate,
                maxDate,
                hideOutOfRange: true,
                enableSwipe: true,
                startOnMonday: true,
                enableKeyboard: true,
                autoCloseOnSelect: true,
                locale: language,
                cancelLabel: caleranButtonLabels.cancelLabel,
                applyLabel: caleranButtonLabels.applyLabel,
                enableMonthSwitcher: true,
                enableYearSwitcher: true,
                prevMonthIcon,
                nextMonthIcon,
                ranges: generateRanges(gtArrival),
                format: "DD/MM/YYYY",
                onbeforeshow: function (caleran) {
                    const form = caleran.$elem.closest('.gt-ws-ctv-form-resa').get(0);
                    if (form) form._caleranOpen = true;
                },
                onhide: function (caleran) {
                    const form = caleran.$elem.closest('.gt-ws-ctv-form-resa').get(0);
                    if (form) form._caleranOpen = false;
                },
                onafterselect: function (caleran, startDate, endDate) {
                    state.gtArrival = startDate.format('DD/MM/YYYY');
                    state.gtDeparture = endDate.format('DD/MM/YYYY');
                    Cookies.set('gtArrival', state.gtArrival);
                    Cookies.set('gtDeparture', state.gtDeparture);

                    // Si pas de bouton submit (mode auto), on déclenche le submit du form.
                    if (caleran.$elem.closest('.gt-ws-ctv-form-resa').find('button[type="submit"]').length <= 0) {
                        state.isLoading = true;
                        state.loaded = false;
                        caleran.$elem.closest('.gt-ws-ctv-form-resa').get(0)
                            .dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
                    }

                    caleran.config.ranges = generateRanges(state.gtArrival);
                    caleran.reDrawCalendars();

                    // Synchroniser d’autres calendriers déjà initialisés sur la page (si plusieurs blocs).
                    jQuery(".gt-caleran-merged, .gt-caleran-arrival, .gt-caleran-departure").each(function () {
                        const instance = jQuery(this).data("caleran");
                        if (!instance) return;
                        instance.config.startDate = startDate;
                        instance.config.endDate = endDate;
                        instance.reDrawCalendars();
                    });
                }
            });

            if (gtArrival && gtDeparture) {
                $merged.val(`${gtArrival} - ${gtDeparture}`);
            }
            return;
        }

        // Mode 2 champs: init groupée arrivée/départ
        if (!arrivalInput || !departureInput) return;
        const $arrival = jQuery(arrivalInput);
        const $departure = jQuery(departureInput);
        if ($arrival.data('caleran') || $departure.data('caleran')) return;

        let startDate = gtArrival && moment(gtArrival, 'DD/MM/YYYY').isValid() ? moment(gtArrival, 'DD/MM/YYYY') : null;
        let endDate = gtDeparture && moment(gtDeparture, 'DD/MM/YYYY').isValid() ? moment(gtDeparture, 'DD/MM/YYYY') : null;
        let startInstance;
        let endInstance;
        const fillInputs = () => {
            if (!startInstance || !endInstance) return;
            startInstance.$elem.val(startDate ? startDate.locale(startInstance.config.format).format(startInstance.config.format) : "");
            endInstance.$elem.val(endDate ? endDate.locale(endInstance.config.format).format(endInstance.config.format) : "");
        };

        $arrival.caleran({
            startDate,
            endDate,
            minDate,
            maxDate,
            hideOutOfRange: true,
            enableSwipe: true,
            startOnMonday: true,
            enableKeyboard: true,
            autoCloseOnSelect: true,
            locale: language,
            cancelLabel: caleranButtonLabels.cancelLabel,
            applyLabel: caleranButtonLabels.applyLabel,
            enableMonthSwitcher: true,
            enableYearSwitcher: true,
            prevMonthIcon,
            nextMonthIcon,
            ranges: generateRanges(gtArrival),
            format: "DD/MM/YYYY",
            oninit: function (instance) {
                startInstance = instance;
                if (startDate) {
                    instance.$elem.val(startDate.locale(instance.config.format).format(instance.config.format));
                }
            },
            onbeforeshow: function (instance) {
                if (startDate && endInstance) {
                    startInstance.config.startDate = startDate;
                    endInstance.config.startDate = startDate;
                }
                if (endDate && endInstance) {
                    startInstance.config.endDate = endDate.clone();
                    endInstance.config.endDate = endDate.clone();
                }
                fillInputs();
                instance.updateHeader();
                instance.reDrawCells();
            },
            onfirstselect: function (instance, start) {
                startDate = start.clone();
                startInstance.globals.startSelected = false;
                startInstance.hideDropdown();
                if (endInstance) {
                    endInstance.showDropdown();
                    endInstance.config.minDate = startDate.clone();
                    endInstance.config.startDate = startDate.clone();
                    endInstance.config.endDate = null;
                    endInstance.globals.startSelected = true;
                    endInstance.globals.endSelected = false;
                    endInstance.globals.firstValueSelected = true;
                    endInstance.setDisplayDate(start);
                    if (endDate && startDate.isAfter(endDate)) {
                        endInstance.globals.endDate = endDate.clone();
                    }
                    endInstance.updateHeader();
                    endInstance.reDrawCells();
                }
                fillInputs();
            }
        });

        $departure.caleran({
            startDate,
            endDate,
            minDate,
            maxDate,
            hideOutOfRange: true,
            enableSwipe: true,
            startOnMonday: true,
            enableKeyboard: true,
            autoCloseOnSelect: true,
            locale: language,
            cancelLabel: caleranButtonLabels.cancelLabel,
            applyLabel: caleranButtonLabels.applyLabel,
            enableMonthSwitcher: true,
            enableYearSwitcher: true,
            prevMonthIcon,
            nextMonthIcon,
            ranges: generateRanges(gtArrival),
            format: "DD/MM/YYYY",
            oninit: function (instance) {
                endInstance = instance;
                if (endDate) {
                    instance.$elem.val(endDate.locale(instance.config.format).format(instance.config.format));
                }
            },
            onbeforeshow: function (instance) {
                if (startDate && startInstance) {
                    startInstance.config.startDate = startDate;
                    endInstance.config.startDate = startDate;
                }
                if (endDate && startInstance) {
                    startInstance.config.endDate = endDate.clone();
                    endInstance.config.endDate = endDate.clone();
                }
                fillInputs();
                instance.updateHeader();
                instance.reDrawCells();
            },
            onafterselect: function (instance, start, end) {
                startDate = start.clone();
                endDate = end.clone();
                endInstance.hideDropdown();
                if (startInstance) {
                    startInstance.config.endDate = endDate.clone();
                    startInstance.globals.firstValueSelected = true;
                }
                fillInputs();
                endInstance.globals.startSelected = true;
                endInstance.globals.endSelected = false;

                state.gtArrival = start.format('DD/MM/YYYY');
                state.gtDeparture = end.format('DD/MM/YYYY');
                Cookies.set('gtArrival', state.gtArrival);
                Cookies.set('gtDeparture', state.gtDeparture);

                instance.config.ranges = generateRanges(state.gtArrival);
                instance.reDrawCalendars();

                // Synchroniser d’autres calendriers déjà initialisés sur la page (si plusieurs blocs).
                jQuery(".gt-caleran-merged, .gt-caleran-arrival, .gt-caleran-departure").each(function () {
                    const caleranInstance = jQuery(this).data("caleran");
                    if (!caleranInstance) return;
                    caleranInstance.config.startDate = startDate;
                    caleranInstance.config.endDate = endDate;
                    caleranInstance.reDrawCalendars();
                });
            }
        });

        if (gtArrival) $arrival.val(gtArrival);
        if (gtDeparture) $departure.val(gtDeparture);

        setTimeout(fillInputs, 100);
    });
};

// Bootstrap vanilla: init au chargement + après rafraîchissements (soft nav / updateURL)
const bootCaleran = () => initCaleranVanilla();
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootCaleran);
} else {
    bootCaleran();
}
window.addEventListener('gt_ws_ctv_updated', bootCaleran);

/**
 * Fait défiler la page vers le formulaire de résa le plus proche.
 * N'impacte pas le chargement des disponibilités (appel indépendant).
 */
const scrollToNearestResaForm = () => {
    const forms = Array.from(document.querySelectorAll('.gt-ws-ctv-form-resa'));
    if (!forms.length) return;

    // Règle générale : privilégier un formulaire non sticky visible dans le flux.
    const preferredForms = forms.filter((form) => !form.classList.contains('sticked'));
    const hasPreferred = preferredForms.length > 0;
    const candidateForms = hasPreferred ? preferredForms : forms;

    let closestForm = null;
    let closestDistance = Infinity;

    candidateForms.forEach((form) => {
        const rect = form.getBoundingClientRect();
        // Distance par rapport au haut de la fenêtre (0 = bord haut visible)
        const distance = Math.abs(rect.top);
        if (distance < closestDistance) {
            closestDistance = distance;
            closestForm = form;
        }
    });

    if (closestForm) {
        // Si aucun formulaire non-sticky n'est disponible, la position d'un form "fixed"
        // (class sticked) fausse le calcul. On prend alors un ancrage parent dans le flux.
        const anchorEl = hasPreferred ? closestForm : (closestForm.parentElement || closestForm);
        const rect = anchorEl.getBoundingClientRect();
        const currentScroll = window.scrollY || window.pageYOffset || 0;
        // Décalage pour laisser apparaître le formulaire sous le header/sticky
        const offset = 150; // ajustable si besoin
        const target = rect.top + currentScroll - offset;
        window.scrollTo({
            top: target < 0 ? 0 : target,
            behavior: 'smooth'
        });
    }
};

const updateURL = async (url) => {
    const router = await import('@wordpress/interactivity-router');
    
    // await router.actions.prefetch(url.toString(),{
    //     // force:false
    // });

    // Navigate to the updated URL
    await router.actions.navigate(url.toString(), {
        // force:true,
        replace:true,
        // timeout:20000
    });

    // Scroll vers le formulaire de résa le plus proche (sans attendre les disponibilités)
    scrollToNearestResaForm();

    fetch(`${state.baseUrl}disponibilites/?arrival=${state.gtArrival}&departure=${state.gtDeparture}&nbPers=${state.gtNbPers}&lang=${state.language}&site_id=${state.siteId}`)
        .then(response => response.json())
        .then(disponibilitesData => {
            let stays = {};
            state.allProductIds.forEach(productId => {
                stays[productId] = disponibilitesData[productId] || [];
            });
            state.stays = stays;


            // If all empty arrays
            // if (Object.values(stays).every(arr => arr.length === 0)) {
            //     if (!url.searchParams.has('gtNoResults')) {
            //         url.searchParams.set('gtNoResults', 'true');
            //         updateURL(url);
            //         return;
            //     }
            // }


        })
        .catch(error => console.error("Erreur lors de la récupération des disponibilités:", error))
        .finally(() => {

            
            store('gt/ctv').actions.sortHebergements();

            const event = new CustomEvent('gt_ws_ctv_updated');
            window.dispatchEvent(event);

            state.isLoading = false;
            state.loaded = true;

        });

};

// Au chargement de la page : si on arrive avec gtScroll=results (après submit), scroll vers le formulaire de résa le plus proche.
// Exécuté sans attendre les disponibilités pour ne pas impacter leur chargement.
const runScrollToResultsOnLoad = () => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('gtScroll') !== 'results') return;
    const url = new URL(window.location.href);
    url.searchParams.delete('gtScroll');
    const cleanUrl = url.pathname + (url.search ? url.search : '') + url.hash;
    window.history.replaceState({}, '', cleanUrl);
    requestAnimationFrame(() => scrollToNearestResaForm());
};
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runScrollToResultsOnLoad);
} else {
    runScrollToResultsOnLoad();
}